import { render, staticRenderFns } from "./Project_Card.vue?vue&type=template&id=535962d9&scoped=true&"
import script from "./Project_Card.vue?vue&type=script&lang=js&"
export * from "./Project_Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535962d9",
  null
  
)

export default component.exports